// extracted by mini-css-extract-plugin
export var inlineLink = "_9g-0";
export var inlineLinkButton = "_9g-1";